import { cn } from "@/lib/utils";

export const LogoFull = ({ className = "h-10" }) => (
  <img src="/logo-full.png" alt="iyalagi.manjat" className={cn("w-auto select-none object-contain", className)} draggable={false} data-testid="brand-logo" />
);

export const CatMascot = ({ className = "w-24", jump = false }) => (
  <img src="/mascot.png" alt="" aria-hidden="true" draggable={false} data-testid="cat-mascot"
    className={cn("pointer-events-none select-none", jump && "cat-jump", className)} />
);

const AV = ["#1A3323", "#3D6F4B", "#5C7F55", "#2A2E2B", "#7C9A6E"];
const hash = (s = "") => [...s].reduce((a, c) => a + c.charCodeAt(0), 0);
const initials = (n = "?") => n.trim().split(/\s+/).slice(0, 2).map((w) => w[0]).join("").toUpperCase();

export const Avatar = ({ name, src, size = 36, className, testId = "avatar" }) => (
  src ? (
    <img src={src} alt={name} loading="lazy" className={cn("shrink-0 rounded-full object-cover ring-2 ring-[#F7F4EA]", className)} style={{ width: size, height: size }} data-testid={testId} />
  ) : (
  <span className={cn("inline-flex shrink-0 items-center justify-center rounded-full font-extrabold text-[#FDFCF8] ring-2 ring-[#F7F4EA]", className)}
    style={{ width: size, height: size, fontSize: size * 0.38, background: AV[hash(name) % AV.length] }} data-testid={testId}>
    {initials(name)}
  </span>
  )
);

export const AvatarStack = ({ names = [], size = 32, max = 6 }) => (
  <div className="flex -space-x-2.5" data-testid="avatar-stack">
    {names.slice(0, max).map((n, i) => <Avatar key={`${n}-${i}`} name={n} size={size} />)}
  </div>
);

export const Hold = ({ className, color = "#3D6F4B" }) => (
  <svg viewBox="0 0 60 50" className={className} aria-hidden="true">
    <path d="M8 30C2 18 14 4 30 5c14 1 26 9 24 23-2 13-16 19-28 17C16 44 12 38 8 30Z" fill={color} />
    <circle cx="31" cy="24" r="4.5" fill="#F7F4EA" opacity=".85" />
  </svg>
);

export const Topo = ({ className }) => (
  <svg viewBox="0 0 400 300" className={cn("pointer-events-none", className)} fill="none" aria-hidden="true">
    {[0, 1, 2, 3, 4, 5].map((i) => (
      <path key={i} stroke="currentColor" strokeWidth="1.3"
        d={`M${-20 + i * 6} ${260 - i * 34}C${80 + i * 10} ${200 - i * 30} ${140} ${290 - i * 40} ${230 + i * 8} ${210 - i * 32}S${360} ${150 - i * 20} ${430} ${190 - i * 30}`} />
    ))}
  </svg>
);

export const Tape = ({ children, className }) => (
  <span className={cn("inline-block -rotate-2 rounded-[4px] bg-[#E3EDD9] px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.14em] text-[#1A3323] shadow-sm", className)}>
    {children}
  </span>
);

export const RouteLine = ({ className }) => (
  <svg viewBox="0 0 200 60" className={cn("pointer-events-none", className)} fill="none" aria-hidden="true">
    <path d="M4 52C40 46 52 14 92 18s52 30 104-12" stroke="currentColor" strokeWidth="2.5" strokeDasharray="2 9" strokeLinecap="round" className="route-dash" />
  </svg>
);
